import { createSelector } from 'reselect';

export const getFeatureFlags = (state) => state.featureFlags || {};

export const getGuidedChecklistVariant = ({
    marketingToolsExperimentVariant: { guidedChecklistVariant } = {},
}) => guidedChecklistVariant || null;

export const getIsMarketingToolsExperimentEnabled = createSelector(
    getFeatureFlags,
    getGuidedChecklistVariant,
    (
        { isMarketingToolsExperimentEnabled = false },
        guidedChecklistVariant = null,
    ) => (guidedChecklistVariant ? isMarketingToolsExperimentEnabled : false),
);
